import * as React from "react";
import { cn } from "@/lib/utils";

interface MarqueeProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Pause animation on hover */
  pauseOnHover?: boolean;
  /** Reverse scroll direction */
  reverse?: boolean;
  /** Duration in seconds (e.g. 40). Default 40s */
  durationSec?: number;
  /** Gap between items in px */
  gapPx?: number;
}

/**
 * Simple horizontal marquee. Duplicates children once and translates -50%
 * for a seamless loop. Uses the `marquee-x` keyframes from tailwind.config.
 */
export function Marquee({
  className,
  children,
  pauseOnHover = true,
  reverse = false,
  durationSec = 40,
  gapPx = 20,
  ...props
}: MarqueeProps) {
  return (
    <div
      {...props}
      className={cn("group relative flex w-full overflow-hidden", className)}
    >
      <div
        className={cn(
          "flex w-max shrink-0 animate-marquee-x",
          pauseOnHover && "group-hover:[animation-play-state:paused]",
        )}
        style={{
          animationDuration: `${durationSec}s`,
          animationDirection: reverse ? "reverse" : "normal",
          gap: `${gapPx}px`,
          paddingRight: `${gapPx}px`,
        }}
      >
        {children}
        {children}
      </div>
    </div>
  );
}
